/**
 * Lead mobile from store entry URLs: ?m=<phone> or /m/<phone> (optional /store prefix).
 * @param {string|URL} [href]
 * @returns {string|null}
 */
export function leadMobileFromUrl(href) {
  try {
    const url =
      href instanceof URL
        ? href
        : new URL(
            typeof href === "string" && href.trim()
              ? href
              : window.location.href,
            window.location.origin
          );
    const fromQuery = url.searchParams.get("m");
    if (fromQuery != null && String(fromQuery).trim() !== "") {
      return String(fromQuery).trim();
    }
    const match = url.pathname.match(/(?:^|\/)m\/([^/]+)/i);
    if (!match?.[1]) return null;
    try {
      return decodeURIComponent(match[1]).trim();
    } catch {
      return String(match[1]).trim();
    }
  } catch {
    return null;
  }
}
